import React from 'react';
import { LogOut, ChevronLeft, Presentation } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const Navbar = ({ title, subtitle, onLogout, showBack, onBack }) => {
  const { currentUser, presenterMode, setPresenterMode } = useAppContext();

  return (
    <nav className="bg-[#01006A] border-b border-[#010059] px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {showBack && (
            <button
              onClick={onBack}
              className="flex items-center gap-1 text-[#9696d4] hover:text-white transition-colors text-sm font-medium"
            >
              <ChevronLeft className="w-4 h-4" />
              Back
            </button>
          )}
          <div className="flex items-center space-x-3">
            <img
              src="/mindset_logo_white.png"
              alt="Mindset logo"
              className="h-8 w-auto object-contain"
            />
            <div className="border-l border-[#4d4db5] pl-3">
              <h1 className="text-sm font-bold text-white leading-tight">{title}</h1>
              {subtitle && <p className="text-xs text-[#9696d4]">{subtitle}</p>}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          {/* Presenter mode toggle */}
          <button
            onClick={() => setPresenterMode(!presenterMode)}
            title={presenterMode ? 'Exit presenter mode' : 'Enter presenter mode'}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors border ${
              presenterMode
                ? 'bg-white text-[#01006A] border-white'
                : 'bg-transparent text-[#9696d4] border-[#4d4db5] hover:text-white hover:border-white'
            }`}
          >
            <Presentation className="w-3.5 h-3.5" />
            {presenterMode ? 'Exit Presenter' : 'Presenter Mode'}
          </button>

          <span className="text-sm text-[#9696d4]">
            {currentUser?.name}
            <span className="ml-1.5 text-xs bg-[#010059] text-[#c0c0e6] px-2 py-0.5 rounded-full capitalize">
              {currentUser?.role}
            </span>
          </span>
          <button
            onClick={onLogout}
            className="flex items-center space-x-1.5 text-[#9696d4] hover:text-white transition-colors"
            title="Log out"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
